import * as types from './types';

export default {
  [types.SET_UNREAD_COUNT_NOTIFICATIONS]: (state, unreadCount) => {
    if (unreadCount && typeof unreadCount === 'number') {
      state.unreadCount = unreadCount;
    } else {
      state.unreadCount = state.notificationList.filter(notification => !notification.isRead).length;
    }
  },

  [types.SET_NOTIFICATION_LIST]: (state, notificationList) => {
    state.notificationList = notificationList;
  },

  [types.ADD_NEW_NOTIFICATION]: (state, notification) => {
    const isNotificationExists = state.notificationList.find(n => n.id === notification.id);

    if (isNotificationExists !== undefined) {
      return;
    }
    state.notificationList.unshift(notification);

    if (state.notificationList.length > 100) {
      state.notificationList.pop();
    }
  },

  [types.SET_DISTURB]: (state, isNotDisturb) => {
    state.isNotDisturb = isNotDisturb;
  },
};
